export * from './buy-win-partner.page'
